import React, { useState } from 'react'

import TriviaQuizModal from '../components/Modals/TriviaQuizModal/TriviaQuizModal'
import StartScreen from '../components/StartScreen/StartScreen'
import QuestionView from '../components/QuestionView/QuestionView'

import ModalEditedBlock from '../components/ModalEditedBlock/ModalEditedBlock'

const TriviaQuiz = ({ blockData: { struct, colorTheme, id, fontFamily = 'Roboto' }, pagesData, onUpdate }) => {
    const [isShowModal, setIsShowModal] = useState(false)

    return (
        <ModalEditedBlock onEdit={() => setIsShowModal(true)}>
            {Object.keys(struct).length && struct.cover.isShowCover ? (
                <StartScreen struct={struct} backgroundColor={colorTheme} fontFamily={`"${fontFamily}", sans-serif`} />
            ) : (
                <QuestionView question={struct.questions[0]} fontFamily={`"${fontFamily}", sans-serif`} />
            )}

            {isShowModal && (
                <TriviaQuizModal
                    data={{
                        pages: pagesData,
                        structure: struct,
                        colorTheme,
                        id,
                        fontFamily: `"${fontFamily}", sans-serif`,
                    }}
                    settings={{ max_width: 960, overlayClose: false }}
                    methods={{
                        closeModal: () => setIsShowModal(false),
                        save: onUpdate,
                    }}
                />
            )}
        </ModalEditedBlock>
    )
}

export default TriviaQuiz
